export default function(organizationId, values = {}) {
  return {
    organizationId,
    organizationContactRoleType: values.organizationContactRoleType
  }
}

